module.exports = __webpack_public_path__ + "img/logo_1.9825e35a.png";